import React from 'react'
//css
import '../assets/css/Dashboard.css';
//component
import AddPanel from './AddPanel';
import Panel from './Panel';
//store
import panels from '../store/panels';
//mobx
import { observer } from 'mobx-react';

@observer
class Dashboard extends React.Component {
  componentDidMount() {
    this.interval = setInterval(() => (panels.syncData()), 10000);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  editShow = () => {
    this.setState({
      show: ''
    })
  }
  render() {
    return (
      <div className="Dashboard">
        {panels.list.map((x, y) => (
          <Panel
            key={x + y}
            eventName={x.eventName}
            data={x.data}
            type={x.type}
            property={x.property}
            tool={x.tool}
            panelName={`${x.tool} ${x.type} ${x.eventName} ${x.property}`}
            eventAPIKey={x.eventAPIKey}
            panelId={x.panelId}
          />
        ))}
        <AddPanel show={'add'} editShow={this.editShow} />
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js